module.exports = __webpack_public_path__ + "static/img/znsj_p1.30301ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsj_p1.png
// module id = X4eG
// module chunks = 19